import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
import VueCookie from "vue-cookie";
import router from "../../router";

Vue.use(VueCookie);
Vue.use(Vuex);
Vue.use(VueAxios, axios);
Vue.prototype.qs = qs;

export default {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    checkLogin: () => {
      axios({
        method: "post",
        data: {
          action: "check_login",
        },
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          if (response.data.error == "INVALID USERNAME OR/AND PASSWORD") {
            router.push("login");
            return false;
          }
          if (response.data.error == "WRONG USERNAME OR PASSWORD") {
            router.push("login");
            return false;
          }
          if (response.data.error == "AUTH FAILED") {
            router.push("login");
            return false;
          }
          if (response.data.error == "LOGIN EXPIRED") {
            router.push("login");
            return false;
          }
        })
        .catch(function(error) {
          throw new Error(error);
        });
    },
  },
};
